import ReportsListItem from '../ReportsListItem';
import ReportsFormExport from '../ReportsFormExport';
import EmptyList from '@/components/Common/EmptyList';
import ReportsListSearchPanel from '../ReportsListSearchPanel';

// @vue/component
export default {
  name: 'ReportsList',

  components: {
    EmptyList,
    ReportsListItem,
    ReportsFormExport,
    ReportsListSearchPanel,
  },

  data() {
    return {
      isModalWithFormExportReportVisible: false,
      generatedRepportUuid: null,
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'reports/getList',
      ]);
    },
    reportsList() {
      return this.$store.getters['reports/list'];
    },
  },

  created() {
    this.$store.dispatch('reports/clearFilteringCriteria');
    this.$store.dispatch('reports/changePage', 1);
  },

  methods: {
    handleChangePage(page) {
      this.$store.dispatch('reports/changePage', page);
    },

    handleShowFormExportReport(report) {
      this.generatedRepportUuid = report;
      this.isModalWithFormExportReportVisible = true;
    },
  },
};
